import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { MasterService } from '../master.service';
import { LoaderService } from 'src/app/common/loader.service';
import { AddSubSpecialityMasterComponent } from './add-sub-speciality/add-sub-speciality.component';

@Component({
  selector: 'app-sub-speciality',
  templateUrl: './sub-speciality.component.html',
  styleUrls: ['./sub-speciality.component.scss']
})
export class SubSpecialityComponent implements OnInit {

  addSpeciality;
  toggleColumn = true;
  searchForm: FormGroup;
  rowData: any[];

  newSpeciality: AddSubSpecialityMasterComponent;
  @ViewChild(AddSubSpecialityMasterComponent, { static: true }) set Content(newObjRef) {
    this.newSpeciality = newObjRef;
  }

  constructor(private router: Router, private formBuilder: FormBuilder, private masterService: MasterService,
    private loaderService: LoaderService) {
    this.getFormGroup();
  }

  ngOnInit() {
    this.search();
  }

  private getFormGroup() {
    this.searchForm = this.formBuilder.group({
      'id': new FormControl(),
      'spId': new FormControl(),
      'code': new FormControl(),
      'descEn': new FormControl(),
      'desc': new FormControl(),
      'codeInternational': new FormControl(),
      'codeLocal': new FormControl(),
    }) 
  } 

  addNew() {
    this.router.navigate(['addSubSpeciality']);
    this.newSpeciality.addTitle = true;
    this.newSpeciality.editTitle = false;
  }

  hideRightDiv() {
    this.addSpeciality = false;
    this.toggleColumn = true;
  }

  search() {
    let saveData = {};
    saveData["master"] = this.searchForm.value;
    saveData["masterShName"] = "SUB_SPECIALITY";
    this.loaderService.display(true);
    this.masterService.searchMaster(saveData).subscribe(response => {
      this.loaderService.display(false);
      if (response && response["result"]) {
        this.rowData = response['result'];
      }

    })
  }

  onRowClicked(event: any) {
    this.addSpeciality = true;
    this.toggleColumn = false;
    this.newSpeciality.addTitle = false;
    this.newSpeciality.editTitle = true;
    const searchData = event.data;
    this.newSpeciality.addForm.patchValue({
      id: searchData.id,
      code: searchData.code,
      descEn: searchData.descEn,
      desc: searchData.desc,
      codeInternational: searchData.codeInternational,
      codeLocal: searchData.codeLocal
    })
  }

  reset() {
    this.searchForm.reset();
  }

}
